module.exports = __webpack_public_path__ + "img/icon-heart.80e26322.svg";